import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Task.css";
import Title from "../../Text/Title/Title";
import BigText from "../../Text/BigText/BigText.jsx";
import { normalizeTaskFromApi } from "../../../Utils/taskUtils.ts";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { Col, Form, Row } from "reactstrap";
import { IFrontTask } from "../../../interfaces/ITask.tsx";
import { useNotification } from "../../../hooks/useNotification";
import ReactMarkdown from "react-markdown";
import {
  FaCirclePlay,
  FaCirclePause,
  FaCalendar,
  FaCircleNodes,
  FaCircleExclamation,
  FaFileLines,
  FaUser,
  FaFilePdf,
  FaFileImage,
  FaPen,
  FaTrash
} from "react-icons/fa6";
import PokerCard from "../../PokerCard/PokerCard.tsx";

import { Grid, Box } from "@mui/material";

function TaskAval() {
  const { id, user } = useParams();
  const { getTaskByTrelloId, newVote } = useApiRequests();
  const { notify } = useNotification();

  const [userVoted, setUserVoted] = useState(false);

  const [items, setItems] = useState([]);
  const [task, setTask] = useState<IFrontTask>({
    title: "",
    category: "",
    ticket: "",
    partnerEmail: "",
    customerEmail: "",
    description: "",
    labelIds: [],
    emailsToNotify: [],
    resources: [],
    memberIds: [],
    membersName: [],
  });

  useEffect(() => {
    const getTask = async () => {
      try {
        const taskData = await getTaskByTrelloId(id);
        if (taskData.success) {
          const normalized = normalizeTaskFromApi(taskData.data, id);
          if (!normalized) {
            notify("Tarefa não encontrada.", { type: "error" });
            return;
          }

          setTask(normalized);
          if (normalized.resources != null && normalized.resources.length > 0) {
            setItems(normalized.resources);
          }

          const members = (normalized.membersName ?? []).map(
            (memberName, index) => ({
              value: normalized.memberIds[index],
              label: memberName,
            })
          );

          const tools = (normalized.toolsName ?? []).map((toolName, index) => ({
            value: normalized.toolsIds[index],
            label: toolName,
          }));
        } else {
          notify(taskData.msg, { type: "error" });
        }
      } catch (error) {
        notify(error, { type: "error" });
      }
    };

    if (id !== "new") {
      getTask();
    }
  }, []);

  const handleWithVote = async (vote: string) => {
    setUserVoted(true);
    const voteObj = {
      TaskId: id,
      UsersVoted: [user],
      VotesValues: [vote],
    };

    try {
      const data = await newVote(voteObj);
      if (data.success) notify("Obrigado por votar!", { type: "success" });
    } catch (error) {
      notify(error, { type: "error" });
    }
  };


  function padZero(number: number) {
    return number.toString().padStart(2, "0");
  }

  function objectIdToDate(objectId: any) {
    const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;

    const date = new Date(timestamp);

    const formattedDate = `${padZero(date.getDate())}/${padZero(
      date.getMonth() + 1
    )}/${date.getFullYear()} ${padZero(date.getHours())}:${padZero(
      date.getMinutes()
    )}:${padZero(date.getSeconds())}`;

    return formattedDate;
  }

  const handleClickResource = (link: string) => {
    window.open(link, "_blank");
  };

  function extrairNomeArquivo(url) {
    // Padrão para procurar na URL
    const padrao = /https:\/\/files\.aprendaerp\.com\.br\.s3[^/]*\/([^/]+)$/;

    // Executa a expressão regular na URL
    const correspondencias = url.match(padrao);

    // Se houver correspondências, retorna o nome do arquivo
    if (url.includes("files.aprendaerp.com.br.s3")) {
      var splited = url.split("/");

      return splited[splited.length - 1]
        .replace(".png", "")
        .replace(".jpeg", "")
        .replace(".jpg", "")
        .replace(".pdf", "")
        .replace(".xml", "");
    } else {
      // Caso contrário, retorna null ou uma mensagem indicando que não foi encontrado
      return url;
    }
  }

  return (
    <div className="page-aval">
      <div className="d-flex align-center justify-content-between w-100">
        <div className="title-and-subtitle">
          <Title>Avaliação de Complexidade</Title>
        </div>
      </div>
      <div className="mt-5 mb-5">
        <Form>
          <Row>
            <Col md={8} lg={12}>
              <BigText type={2}>{task.title}</BigText>
            </Col>
          </Row>
          <span className="divider"></span>
          <Row className="mt-5">
            <span className="theme-text-color">
              Leia a descrição da tarefa e selecione o card no final da página!
            </span>
          </Row>
          <Row className="mt-5 mb-3">
            <Col md={6} lg={8}>
              <span className="info-description mb-3">Descrição:</span>
              {task.description != undefined && task.description != null && (
                <ReactMarkdown className="markdown theme-text-color">
                  {task.description.replace(/\n/g, "  \n")}
                </ReactMarkdown>
              )}
            </Col>
          </Row>
          <Box sx={{ flexGrow: 1 }}>
            <span className="theme-text-color">
              <b>Evidências: </b>
            </span>
            <Grid container rowSpacing={1} spacing={1}>
              {task.evidencies != undefined && task.evidencies != null && (
                <>
                  {task.evidencies.map((item, index) => {
                    return (
                      <Grid>
                        <div
                          key={index}
                          style={{
                            border: "none",
                            cursor: "pointer",
                            background: "#2528ff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "1rem",
                            borderRadius: "1rem",
                            marginTop: "8px",
                            marginLeft:"4px",
                            marginRight:"4px",

                          }}
                          onClick={() => handleClickResource(item.link)}
                        >
                          {item.link.includes("png") ? (
                            <FaFileImage size={32} color="#fff" />
                          ) : item.link.includes("pdf") ? (
                            <FaFilePdf size={32} color="#fff" />
                          ) : (
                            <FaFileLines size={32} color="#fff" />
                          )}
                          <span style={{ textAlign: "center" }}>
                            {extrairNomeArquivo(item.link)}
                          </span>
                          <span>{objectIdToDate(item.id)}</span>
                        </div>
                      </Grid>
                    );
                  })}
                </>
              )}
            </Grid>
          </Box>
          <Row className="mt-5">
            <h3 className="theme-text-color">Sumário:</h3>
            <ul style={{ marginLeft: "2rem" }}>
              <li className="theme-text-color">
                1, 2 Tarefas muito pequenas, que podem ser concluídas
                rapidamente
              </li>
              <li className="theme-text-color">
                3, 5 Tarefas de tamanho médio, que podem levar algum tempo
              </li>
              <li className="theme-text-color">
                8, 13 Tarefas maiores, que podem levar bastante tempo
              </li>
              <li className="theme-text-color">
                21 Tarefas muito grandes e incertas, geralmente divididas em
                tarefas menores antes de serem realizadas
              </li>
            </ul>
          </Row>
          <Row>
            {!userVoted ? (
              <>
                <PokerCard click={handleWithVote}>1</PokerCard>
                <PokerCard click={handleWithVote}>2</PokerCard>
                <PokerCard click={handleWithVote}>3</PokerCard>
                <PokerCard click={handleWithVote}>5</PokerCard>
                <PokerCard click={handleWithVote}>8</PokerCard>
                <PokerCard click={handleWithVote}>13</PokerCard>
                <PokerCard click={handleWithVote}>21</PokerCard>
              </>
            ) : (
              <span style={{ color: "red" }}>
                <b>Você já votou!</b>
              </span>
            )}
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default TaskAval;
